<form #paymentPeriodicForm="ngForm" validate>
  <h5> <b> <i translate> MemoPayments.Payment Scheduling </i> </b> </h5>
  <hr class="mb-5">
<!-- Primera fila -->
  <div class="p-fluid grid mt-3">
    <div class="flex-container">

      <div class="p-field col-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 pr-4 full-width">
        <p-floatlabel>
          <p-datePicker
            name="startTaskDate"
            #startTaskDate="ngModel"
            appendTo="body"
            dateFormat="yy-mm-dd"
            inputId="startTaskDate"
            [firstDayOfWeek]="firstDayWeek"
            [(ngModel)]="payment.startTaskDate"
            [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
            [readonlyInput]="true"
            [showButtonBar]="true"
            [showIcon]="true"
            (onSelect)="setStartTaskDate($event)"
            required
          >
          </p-datePicker>
          <label class="required" for="startTaskDate" translate> MemoPayments.Extraction Start Date </label>
        </p-floatlabel>
      </div>

      <div *ngIf="isTaskEditable || isNewPayment"
           class="p-field col-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 pr-4 full-width">
        <p-floatlabel>
          <p-datePicker
            name="endTaskDate"
            #endTaskDate="ngModel"
            appendTo="body"
            dateFormat="yy-mm-dd"
            inputId="endTaskDate"
            [firstDayOfWeek]="firstDayWeek"
            [(ngModel)]="payment.endTaskDate"
            [disabled]="paymentSavedOk"
            [minDate]="today"
            [readonlyInput]="true"
            [showButtonBar]="true"
            [showIcon]="true"
            (onSelect)="setEndTaskDate($event)">
          </p-datePicker>
          <label for="endTaskDate" translate> MemoPayments.Extraction End Date </label>
        </p-floatlabel>
        <small *ngIf="endTaskDateNotHigherThanToday" class="text-danger" translate> MemoPayments.Incorrect Extraction End Date Today </small>
        <small *ngIf="!endTaskDateNotHigherThanToday && endTaskDateNotHigherThanStartDate" class="text-danger" translate>
          MemoPayments.Incorrect Extraction End Date
        </small>
        <small *ngIf="endTaskDateError.description" class="text-danger" translate> {{ endTaskDateError.description }} </small>
      </div>
      <!-- Fecha expiración de tarea (deshabilitado) -->
      <div *ngIf="!isNewPayment && !isTaskEditable">
        <p-floatlabel>
          <input pInputText *ngIf="!isTaskEditable && !isNewPayment"
                 name="endTaskDate"
                 type="text"
                 [disabled]="true"
                 [(ngModel)]="payment.sEndTaskDate"/>
          <label for="endTaskDate" translate>MemoPayments.Extraction End Date</label>
        </p-floatlabel>
      </div>
    </div>
  </div>

<!-- Segunda fila -->
  <div class="p-fluid grid mt-4">
    <!-- Mes -->
    <div class="p-field col pr-4">
      <p-floatlabel>
        <input pInputText
               #month="ngModel"
               type="text"
               name="month"
               [(ngModel)]="payment.memoPeriodic.month"
               [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
               [ngClass]="{ 'invalid-colors': month.touched && month.errors }"
               required
               >
        <label for="month" class="required" translate>Month</label>
      </p-floatlabel>
    </div>
    <!-- Día del mes -->
    <div class="p-field col pr-4">
      <p-floatlabel>
        <input pInputText
               #dayMonth="ngModel"
               name="dayMonth"
               type="text"
               [(ngModel)]="payment.memoPeriodic.dayMonth"
               [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
               [ngClass]="{ 'invalid-colors': dayMonthTouched  && dayMonth.errors }"
               (blur)="dayMonthTouched = true"
               required
               >
        <label for="dayMonth" class="required" translate>Day Month</label>
      </p-floatlabel>
    </div>
    <!-- Día de la semana -->
    <div class="p-field col pr-4">
      <p-floatlabel>
        <input pInputText
               #dayWeek="ngModel"
               name="dayWeek"
               type="text"
               [(ngModel)]="payment.memoPeriodic.dayWeek"
               [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
               [ngClass]="{ 'invalid-colors': dayWeekTouched  && dayWeek.errors }"
               (blur)="dayWeekTouched = true"
               required
               >
        <label for="dayWeek" class="required" translate>Day Week</label>
      </p-floatlabel>
    </div>
  </div>
<!-- tercera fila -->
  <div class="p-fluid grid mt-4">
    <!-- Hora -->
    <div class="p-field col pr-4">
      <p-floatlabel>
        <input pInputText
               #hour="ngModel"
               name="hour"
               type="text"
               [(ngModel)]="payment.memoPeriodic.hour"
               [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
               [ngClass]="{ 'invalid-colors': hour.touched  && hour.errors }"
               required
               >
        <label for="hour" class="required" translate>Hour</label>
      </p-floatlabel>
    </div>
    <!-- Minutos -->
    <div class="p-field col pr-4">
      <p-floatlabel>
        <input pInputText
               #minutes="ngModel"
               name="minutes"
               type="text"
               [(ngModel)]="payment.memoPeriodic.minutes"
               [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk"
               [ngClass]="{ 'invalid-colors': minutes.touched  && minutes.errors }"
               required
               >
        <label for="minutes" class="required" translate>Minutes</label>
      </p-floatlabel>
    </div>
  </div>

<!-- Actions -->
  <h5 class="mt-3"> <b> <i translate> Actions </i> </b> </h5>
  <hr class="mb-4">
  <!-- Cuarta fila -->
  <div class="p-fluid grid mt-2">
    <!-- Activar esta tarea -->
    <div class="p-field col pr-1">
      <div class="col gap-1 d-flex">
        <p-checkbox #enableTask="ngModel" name="enableTask" [(ngModel)]="payment.memoPeriodic.isEnabled"          [binary]="true"
          [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk">
        </p-checkbox>
        <label for="enableTask" class="ml-2 mt-1" translate>MemoPayments.Enable Task</label>
      </div>
    </div>

    <!-- Execute now -->
    <div class="p-field col pr-2">
      <div class="col gap-1 d-flex">
        <p-checkbox
          #executeNow="ngModel"
          name="executeNow"
          [(ngModel)]="payment.memoPeriodic.executeNow"
          [binary]="true"
          [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk">
        </p-checkbox>
        <label for="executeNow" class="ml-2 mt-1" translate> Common.Execute Now </label>
      </div>
    </div>
  </div>
</form>
